import { Button, Col, Input, Row } from "antd";
import React, { useState } from "react";
import { searchStaffOperator } from "../../actions/staff-registration.action";
import { isValid } from "../../utils/utilities";

export const StaffSearch = (props) => {

    const [phoneNumber, setPhoneNumber] = useState("");
    const [searched, setSearched] = useState(false);
    const [operators, setOperators] = useState([]);

    const onSearch = () => {
        if (!isValid(phoneNumber)) {
            return;
        }
        searchStaffOperator(phoneNumber, (payload) => {
            let result = Array.isArray(payload) ? payload : (isValid(payload) ? [payload] : []);
            setOperators(result);
            setSearched(true);
        }, () => {
            setOperators([]);
            setSearched(true);
        });
    }

    return (
        <div className="staff-search-root">
            <Row gutter={[16, 16]} align="middle">
                <Col>
                    <Input
                        placeholder="Phone Number"
                        style={{ width: 220 }}
                        value={phoneNumber}
                        onChange={(e) => {
                            setPhoneNumber(e.target.value);
                            setSearched(false);
                        }}
                        onPressEnter={onSearch}
                    />
                </Col>
                <Col>
                    <Button onClick={onSearch}>Search</Button>
                </Col>
            </Row>
            {searched &&
                <div className="staff-search-result" style={{ padding: '8px 0' }}>
                    {operators.length > 0 ?
                        operators.map((operator, index) => (
                            <div key={operator.operator_code || index}>
                                {operator.name ? `${operator.name} (${operator.operator_code})` : operator.operator_code}
                            </div>
                        ))
                        :
                        <div>No operator found for this phone number.</div>
                    }
                </div>
            }
        </div>
    );
}
